import { useSeoPage } from '../hooks/useSeoPage';
import { SeoHead } from './SeoHead';

interface DynamicSeoHeadProps {
  slug: string;
  fallback?: {
    title: string;
    description: string;
    keywords?: string;
    jsonLd?: object | object[];
  };
}

export function DynamicSeoHead({ slug, fallback }: DynamicSeoHeadProps) {
  const { seoData, loading } = useSeoPage(slug);

  if (loading) {
    return null;
  }

  if (!seoData && !fallback) {
    return null;
  }

  const data = seoData || fallback;

  if (!data) {
    return null;
  }

  const canonicalPath = seoData?.canonical_url || `/${slug === '/' ? '' : slug}`;
  const jsonLd = seoData?.structured_data_json || (fallback && 'jsonLd' in fallback ? fallback.jsonLd : undefined);

  return (
    <SeoHead
      title={seoData?.title || data.title}
      description={seoData?.meta_description || data.description}
      canonical={canonicalPath}
      keywords={seoData?.keywords || (fallback && 'keywords' in fallback ? fallback.keywords : undefined)}
      ogImage={seoData?.og_image}
      jsonLd={jsonLd}
    />
  );
}
